import { useCallback } from "react";
import { setIsPurePage, setIsMobileAi, setMobileToken, resetMobile } from "./mobile.slice";
import { useAppDispatch, useAppSelector } from "../redux/redux.hook";

const useMobile = () => {
  const dispatch = useAppDispatch();
  const { isPurePage, isMobileAi, token } = useAppSelector((state) => state.mobile);

  const updateIsPurePage = useCallback(
    (value: boolean) => {
      dispatch(setIsPurePage(value));
    },
    [dispatch],
  );

  const updateIsMobileAi = useCallback(
    (value: boolean) => {
      dispatch(setIsMobileAi(value));
    },
    [dispatch],
  );

  const updateMobileToken = useCallback(
    (value: string) => {
      dispatch(setMobileToken(value));
    },
    [dispatch],
  );

  const reset = useCallback(() => {
    dispatch(resetMobile());
  }, [dispatch]);

  return {
    isPurePage,
    isMobileAi,
    token,
    updateIsPurePage,
    updateIsMobileAi,
    updateMobileToken,
    reset,
  };
};

export default useMobile;
